import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { Achievements } from "@/components/Achievements";
import { Screenshots } from "@/components/Screenshots";
import { HowItWorks } from "@/components/HowItWorks";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { GetStarted } from "@/components/GetStarted";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function Home() {
  return (
    <div className="min-h-screen overflow-x-clip bg-crave-bg font-sans text-crave-cream">
      <Seo
        title="Foodie Crave: Discover & Dine | Restaurant Discovery & Dining Experiences"
        description="Discover restaurants, save places to try, track visits, and remember your favorite dining experiences with Foodie Crave. Explore, dine, and revisit."
        ogTitle="Foodie Crave: Discover & Dine"
        ogDescription="Going out instead of eating in. Discover places to eat, save favorites, track dining experiences, and invite friends when you want company."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Achievements />
        <Screenshots />
        <HowItWorks />
        <Pricing />
        <Faq />
        <GetStarted />
      </main>
      <Footer />
    </div>
  );
}
